module.exports = "/_next/static/chunks/images/story-background-a63ef445764598ffb4583824dbf2ae16.svg";